import { cn } from '@ui/lib/cn';

const iconProps = {
  'aria-hidden': true,
  focusable: 'false',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  className: 'h-3 w-3',
} as const;

export const BriefcaseIcon = () => (
  <svg {...iconProps}>
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

export const CalendarIcon = () => (
  <svg {...iconProps}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const ClockIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const CheckIcon = () => (
  <svg {...iconProps}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const CopyIcon = () => (
  <svg {...iconProps}>
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

export const ChevronLeftIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5')}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRightIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5', className)}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const HomeIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5', className)}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-5h-2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  </svg>
);

export const ChevronUpIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5', className)}>
    <polyline points="18 15 12 9 6 15" />
  </svg>
);

export const ChevronDownIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5', className)}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const LogOutIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5 shrink-0')}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const FilterIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5 shrink-0 text-text-3')}>
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

export const PencilIcon = () => (
  <svg {...iconProps}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

export const TrashIcon = () => (
  <svg {...iconProps}>
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </svg>
);

export const PlusIcon = () => (
  <svg {...iconProps}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const ArrowUpIcon = () => (
  <svg {...iconProps}>
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

export const ExternalLinkIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3 w-3 shrink-0')}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-6 w-6 text-accent')}>
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export const UserMinusIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-6 w-6', className)}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="17" y1="11" x2="23" y2="11" />
  </svg>
);

export const CodeIcon = () => (
  <svg {...iconProps} className={cn(iconProps.className, 'h-3.5 w-3.5')}>
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

export const WarningIcon = () => (
  <svg
    {...iconProps}
    className={cn(iconProps.className, 'h-4 w-4 shrink-0')}
    style={{ marginTop: 1 }}
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const CheckCircleIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, className)}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const ShieldIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={cn(iconProps.className, className)}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

export const DownloadIcon = ({ className }: { className?: string }) => (
  <svg
    {...iconProps}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={cn(iconProps.className, 'h-3.5 w-3.5', className)}
  >
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
